import React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
  useMediaQuery,
  Toolbar,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // aging
import LocalMallIcon from "@mui/icons-material/LocalMall";
import { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  fAlertToast,
  getStatusStyle,
  toArrayFromCSV,
  toCSVFromArray,
} from "../../Utility/Utilitys";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGridPro,
  useGridApiRef,
  gridRowIdsSelector,
} from "@mui/x-data-grid-pro";
import { confirmAlert } from "react-confirm-alert";
import {
  GET_API_RSP_Change_Approve_Reject_Type_GetRow,
  GET_API_RSP_Change_Approve_Update,
  GET_API_RSP_Change_Request_Basket_GetRow,
  RSPCRA_Reverse,
} from "../../Server/ApiV2";
import MultiLocationAutocomplete from "./Components/MultiLocationAutocomplete";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import axios from "axios";
import { getGlobals } from "../../Configs";
import { DataGrid, GridFooter, GridFooterContainer } from "@mui/x-data-grid";
import { LocalOffer } from "@mui/icons-material";
import { PromotionModal } from "./Components/Promotiom";
import PromotionAutocomplete from "../RSPChangeRequest/proccessComponent/PromotionAutocomplete";

const RSPChangeApproveModal = ({
  UserID,
  handleClose,
  summaryLoad,
  type,
  HeadObject,
  setHeadObj,
  DetailData,
  setDetailData,
  Location,
  
}) => {
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const LABEL_WIDTH = 120;
   const locationArr = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
    const headData = useSelector(
      (state) => state.SliceRSPChangeRequest.value.Head
    );
  const btnMediaQuery = useMediaQuery("(max-width:1150px)");

  const [reasonTypeList, setReasonTypeList] = useState([]);
  const [webReportOpen, setWebReportOpen] = useState(false);
  const [webReportUrl, setWebReportUrl] = useState("");

  const [stockModal, setStockModal] = useState({ open: false, row: null });
  const [stockRows, setStockRows] = useState([]);
  const [loadingStock, setLoadingStock] = useState(false);

  const [agingModal, setAgingModal] = useState({ open: false, row: null });
  const [agingRows, setAgingRows] = useState([]);
  const [loadingAging, setLoadingAging] = useState(false);

    const promoInit={
      PromoId: "",
      FromDate: null,
      ToDate: null,
      Loc: [],
      Narration: "",
      isActive: false,
    }
    
    const [promotionModal, setPromotionModal] = useState(false);
    const [promoObj, setPromoObj] = useState(promoInit);
    const [basketRows, setBasketRows] = useState([]);
    const [filteredBasketRows, setfilteredBasketRows] = useState([]);


  const totalStkQty = React.useMemo(
    () => stockRows.reduce((sum, row) => sum + (Number(row.StkQty) || 0), 0),
    [stockRows]
  );

  const totalStkVal = React.useMemo(
    () => stockRows.reduce((sum, row) => sum + (Number(row.StkVal) || 0), 0),
    [stockRows]
  );

  const baseURL = getGlobals().API_BASE_URL;
  const toolbar = {
    backgroundColor: "#0d73bb",
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    minHeight: "40px !important",
  };

  const stockColumns = [
    {
      field: "Location",
      headerName: "Location",
      flex: 1,
      minWidth: 150,
    },
{
  field: "StkQty",
  headerName: "Stock Qty",
  type: "number",
  align: "center",
  headerAlign: "center",
  width: 120,
  valueFormatter: ({ value }) => (value != null ? Number(value).toFixed(2) : "")
},
    {
      field: "StkVal",
      headerName: "Stock Value",
      type: "number",
      width: 120,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => Number(params.value).toFixed(2),
    },
  ];
  const handleOpenStock = async (row) => {
    setStockModal({ open: true, row });
    const loader = document.getElementById("loader");
    try {
      if (loader) loader.style.display = "flex";
      const response = await axios.post(
        `${baseURL}Master/Items_Stock_Advance_GetRow_Short_Detail_CSV_LOC`,
        {
          ItmCd: row.B_Itmcd,
          LocCSV: row.B_LocationCSV,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        setStockRows(response?.data?.data ?? []);
      } else {
        setStockRows([]);
      }
    } catch (error) {
      console.error("Error fetching stock:", error);
      setStockRows([]);
    } finally {
      if (loader) loader.style.display = "none";
    }
  };

  const getBasketRows = async () => {
    try {
      const res = await GET_API_RSP_Change_Request_Basket_GetRow();
      if (res?.status === 200) {
        setBasketRows(res?.data?.ResultSet || []);
        setfilteredBasketRows(res?.data?.ResultSet || []);
      }
    } catch (error) {}
  };

    const headSelectedLocation = useMemo(() => {
    return toArrayFromCSV(headData?.A_LocCSV);
  }, [headData?.A_LocCSV]);

  const handleCloseStock = () => setStockModal({ open: false, row: null });
  const agingColumns = [
    // Basic identifiers
    {
      field: "Loc",
      headerName: "Loc",
      width: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "LocName",
      headerName: "Location",
      width: 120,
    },

    {
      field: "NegativeVal",
      headerName: "Negative",
      type: "number",
      flex: 0.6,
      minWidth: 68,
      valueFormatter: (p) => p.value?.toFixed(2),
      align: "right",
      headerAlign: "center",
    },
    // Aging Buckets
    {
      field: "0-30",
      headerName: "0-30",
      type: "number",
      flex: 0.6,
      minWidth: 44,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "31-60",
      headerName: "31-60",
      type: "number",
      flex: 0.2,
      minWidth: 50,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "61-90",
      headerName: "61-90",
      type: "number",
      flex: 0.2,
      minWidth: 50,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "91-120",
      headerName: "91-120",
      type: "number",
      flex: 0.6,
      minWidth: 50,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "121-150",
      headerName: "121-150",
      type: "number",
      flex: 0.6,
      minWidth: 60,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "151-180",
      headerName: "151-180",
      type: "number",
      flex: 0.6,
      minWidth: 60,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "181-210",
      headerName: "181-210",
      type: "number",
      flex: 0.6,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "211-240",
      headerName: "211-240",
      type: "number",
      flex: 0.6,
      minWidth: 64,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "241-270",
      headerName: "241-270",
      type: "number",
      flex: 0.6,
      minWidth: 64,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "271-300",
      headerName: "271-300",
      type: "number",
      flex: 0.6,
      minWidth: 64,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "301-330",
      headerName: "301-330",
      type: "number",
      flex: 0.6,
      minWidth: 64,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "331-360",
      headerName: "331-360",
      type: "number",
      flex: 0.6,
      minWidth: 64,
      align: "center",
      headerAlign: "center",
    },

    {
      field: ">360",
      headerName: ">360",
      type: "number",
      flex: 0.6,
      minWidth: 44,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "StkQty",
      headerName: "StockQty",
      type: "number",
      align: "right",
      headerAlign: "right",
      flex: 0.8,
      minWidth: 70,
      cellClassName: "Stk-cell", 
    },
    {
      field: "StkValue",
      headerName: "StockVal",
      type: "number",
      align: "right",
      headerAlign: "right",
      flex: 1,
      minWidth: 70,
      valueFormatter: (p) => p.value?.toFixed(2),
        cellClassName: "StkVal-cell", 
    },
    {
      field: "Consumption",
      headerName: "Consumption",
      type: "number",
      flex: 0.8,
      minWidth: 98,
      valueFormatter: (p) => p.value?.toFixed(2),
      align: "right",
      headerAlign: "right",
    },

    {
      field: "ShelfQty",
      headerName: "Shelf Qty",
      type: "number",
      flex: 0.7,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "SaleOutQty",
      headerName: "Sale Out Qty",
      type: "number",
      flex: 0.7,
      minWidth: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "SaleOutvalue",
      headerName: "Sale Out Value",
      type: "number",
      flex: 0.7,
      minWidth: 110,
      valueFormatter: (p) => p.value?.toFixed(2),
      align: "right",
      headerAlign: "right",
    },
    {
      field: "ShelfQty2",
      headerName: "Shelf Qty 2",
      type: "number",
      flex: 0.7,
      minWidth: 85,
      align: "center",
      headerAlign: "center",
    },
  ];
  const totals = React.useMemo(() => {
  // identify the slice of columns we care about
  const start = agingColumns.findIndex(c => c.field === "NegativeVal");
  const end   = agingColumns.findIndex(c => c.field === "StkValue");
  const colsToSum = agingColumns.slice(start, end + 1);

  // one pass through rows → one object with all sums
  return agingRows.reduce((acc, row) => {
    colsToSum.forEach(col => {
      const v = Number(row[col.field]) || 0;
      acc[col.field] = (acc[col.field] || 0) + v;
    });
    return acc;
  }, {});          // start from an empty object
}, [agingRows, agingColumns]);

 const handleOpenPromotion = async (promoId) => {
    setPromotionModal(true);
   await getBasketRows();
    const loader = document.getElementById("loader");
    try {
       if (loader) loader.style.display = "flex";
      const response = await axios.post(
        `${baseURL}Master/RSPCR_BK_Getrow`,
        { P_PromoId: promoId },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response?.data?.Type === "Success") {
        setPromoObj((prev) => ({
          ...prev,
          ...response?.data?.ResultSet[0],
          isActive: true,
        }));
      }
    } catch (error) {
      setBasketRows([])
      setPromoObj((prev) => ({...prev,...promoInit}))
      fAlertToast("FAILED",error?.response?.data?.message || error?.message)
    } finally {
       if (loader) loader.style.display = "none";
    }
  };

  const handleOpenAging = async (row) => {
    setAgingModal({ open: true, row });
    setLoadingAging(true);

    try {
      const response = await axios.post(
        `${baseURL}Master/V2_ULAT_STOCKANALYSIS_AGEING_COMMON_LOC`,
        {
          UserCd: UserID || "",
          ItmCd: row.B_Itmcd,
          Loc: row.B_LocationCSV,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        setAgingRows(response?.data?.data ?? []);
      } else {
        setAgingRows([]);
      }
    } catch (error) {
      console.error("Error fetching aging data:", error);
      setAgingRows([]);
    } finally {
      setLoadingAging(false);
    }
  };

  const handleCloseAging = () => setAgingModal({ open: false, row: null });
  const vMediaQuery = useMediaQuery("(max-width:900px)");

  const isActionButtonDisabled = useMemo(() => {
    if (type === "") {
      return (
        HeadObject?.ApproveStatus === "POST" ||
        HeadObject?.ApproveStatus === "REJECT"
      );
    }
    if (type === "CM") {
      return (
        HeadObject?.A_StatusCM === "POST" || HeadObject?.A_StatusCM === "REJECT"
      );
    }
    if (type === "PM") {
      return (
        HeadObject?.A_StatusPM === "POST" || HeadObject?.A_StatusPM === "REJECT"
      );
    }
    return false;
  }, [type, HeadObject]);

  const shouldShowReverseButton = () => {
    if (!HeadObject) return false;
    const aStatusPM = HeadObject?.A_StatusPM?.toUpperCase();
    const aStatusCM = HeadObject?.A_StatusCM?.toUpperCase();
    const aStatus = HeadObject?.A_Status?.toUpperCase();
    const approveStatus = HeadObject?.ApproveStatus?.toUpperCase();

    if (type === "") {
      return (
        aStatusPM === "REJECT" && aStatusCM === "POST" && aStatus !== "ENTER"
      );
    }

    if (type === "CM") {
      return (
        // approveStatus === "REJECT" &&
        aStatusPM === "REJECT" && aStatusCM === "POST"
      );
    }

    if (type === "PM") {
      return (
        approveStatus === "REJECT" &&
        aStatusPM === "POST" &&
        aStatusCM === "POST"
      );
    }

    return false;
  };

  const getOldCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-old" : "";
  const getNewCellClass = (oldValue, newValue) =>
    oldValue !== newValue ? "cell-new" : "";

  const columnGroupingModel = [
    {
      groupId: "Old",
      headerAlign: "center",
      align: "center",
      children: [
        { field: "B_Old_RSP" },
        { field: "B_Old_RSPVat" },
        { field: "B_Old_GPPerc" },
        { field: "B_Old_MarkupPerc" },

        // { field: "RSP_ReasonName" },
      ],
    },
    {
      groupId: "Requested",
      headerAlign: "center",
      align: "center",
      children: [
        { field: "B_New_RSP" },
        { field: "B_New_RSPVat" },
        { field: "B_New_GPPerc" },
        { field: "B_New_MarkupPerc" },
        // { field: "RSPVAT_ReasonName" },
      ],
    },
    {
      groupId: "New",
      headerAlign: "center",
      align: "center",
      children: [
        { field: "B_Appr_RSP" },
        { field: "B_Appr_RSPVat" },
        { field: "B_Appr_GPPerc" },
        { field: "B_Appr_MarkupPerc" },

        // { field: "GPPerc_ReasonName" },
      ],
    },
    // {
    //   groupId: "Markup Percentage",
    //   children: [{ field: "B_Appr_MarkupPerc" }],
    // },
  ];
  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    setDetailData((prev) => {
      if (!Array.isArray(prev)) return prev;

      const idx = prev.findIndex((r) => r.B_Srno === params.row.B_Srno);
      if (idx < 0) return prev;

      const row = prev[idx];
      const parsed = parser(value, row, params);

      const updates =
        parsed !== null && typeof parsed === "object" && !Array.isArray(parsed)
          ? parsed
          : { [fieldName]: parsed };

      const next = [...prev];
      next[idx] = { ...row, ...updates };
      return next;
    });
  };

  const computeApprovalFromRSP = (row, input) => {
    const rsp = Number.parseFloat(input) || 0;
    const cost = Number.parseFloat(row?.B_CostPrice) || 0;
    const taxPerc = Number.parseFloat(row?.TaxPerc) || 0; // keep your row keys
    const addiCess = Number.parseFloat(row?.AddiCessAmt) || 0; // keep your row keys

    const vatAmount = rsp * (taxPerc / 100);
    const rspWithVAT = rsp + vatAmount + addiCess;

    const gpPerc = rsp === 0 ? 0 : ((rsp - cost) / rsp) * 100;
    const markupPerc = cost === 0 ? 0 : ((rsp - cost) / cost) * 100;

    return {
      B_Appr_RSP: rsp, // VAT-exclusive
      B_Appr_RSPVat: Number(rspWithVAT.toFixed(2)), // VAT-inclusive
      B_Appr_GPPerc: Number(gpPerc.toFixed(2)),
      B_Appr_MarkupPerc: Number(markupPerc.toFixed(2)),
    };
  };
  const computeApprovalFromVAT = (row, input) => {
    const vatRSP = Number.parseFloat(input) || 0;
    const taxPerc = Number.parseFloat(row?.TaxPerc) || 0;
    const cost = Number.parseFloat(row?.B_CostPrice) || 0;
    const addiCess = Number.parseFloat(row?.AddiCessAmt) || 0;

    const denom = 1 + taxPerc / 100;
    const rspRaw = denom === 0 ? 0 : (vatRSP - addiCess) / denom; // VAT-exclusive RSP

    const rsp = Number.isFinite(rspRaw) ? rspRaw : 0;

    const gpPerc = rsp === 0 ? 0 : ((rsp - cost) / rsp) * 100; // (RSP - Cost)/RSP
    const markupPerc = cost === 0 ? 0 : ((rsp - cost) / cost) * 100; // (RSP - Cost)/Cost

    return {
      B_Appr_RSPVat: Number(vatRSP.toFixed(2)),
      B_Appr_RSP: Number(rsp.toFixed(4)),
      B_Appr_GPPerc: Number(gpPerc.toFixed(2)),
      B_Appr_MarkupPerc: Number(markupPerc.toFixed(2)),
    };
  };

  const fValidationHead = () => {
    let isValid = true;
    if (HeadObject?.A_TransId === "") {
      fAlertToast("FAILED", "Trans Id should not be empty");
      return;
    }
    if (HeadObject?.A_Date === "") {
      fAlertToast("FAILED", "Date should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.A_Loc === "") {
      fAlertToast("FAILED", "Location should not be empty");
      isValid = false;
      return;
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    for (const item of DetailData || []) {
      if (
        item.B_Srno === "" ||
        item.B_Srno === undefined ||
        item.B_Srno === null
      ) {
        fAlertToast("FAILED", "Sr. No is required.");
        isValid = false;
        break;
      }

      if (
        item.B_Itmcd === "" ||
        item.B_Itmcd === undefined ||
        item.B_Itmcd === null
      ) {
        fAlertToast("FAILED", "Item Code is required.");
        isValid = false;
        break;
      }

      if (
        item.B_Appr_RSP === "" ||
        item.B_Appr_RSP === undefined ||
        item.B_Appr_RSP === null
      ) {
        fAlertToast("FAILED", "Approve rsp is required.");
        isValid = false;
        break;
      }

      if (
        item.B_Appr_RSPVat === "" ||
        item.B_Appr_RSPVat === undefined ||
        item.B_Appr_RSPVat === null
      ) {
        fAlertToast("FAILED", "Approve vatrsp is required.");
        isValid = false;
        break;
      }
      if (
        item.B_Appr_GPPerc === "" ||
        item.B_Appr_GPPerc === undefined ||
        item.B_Appr_GPPerc === null
      ) {
        fAlertToast("FAILED", "Approve gp precentage is required.");
        isValid = false;
        break;
      }
    }

    return isValid;
  };
  const stopGridArrowNavigation = (e) => {
    const k = e.key;

    if (
      k === "ArrowLeft" ||
      k === "ArrowRight" ||
      k === "Home" ||
      k === "End"
    ) {
      e.stopPropagation();
    }
  };

  const fSave = async (isApproved, name, isRejected = false) => {
    try {
      if (!isApproved && name === "Saved") {
        const isDetailValid = fValidationDetail();
        if (!isDetailValid) return;
      }
      const items = DetailData?.map((item) => {
        const {
          B_TransId,
          ItemName,
          B_Unit,
          UnitName,
          Department,
          B_VendorName,
          B_LocationcsvName,
          B_Old_RSP,
          B_Old_RSPVat,
          B_Old_GPPerc,
          B_New_RSP,
          B_New_RSPVat,
          B_New_GPPerc,
          B_Type,
          TypeName,
          B_Competitor,
          CompetitorName,
          B_RefDocNo,
          B_Vendor,
          B_Narration,
          B_CostPrice,
          B_Old_MarkupPerc,
          B_New_MarkupPerc,
          RowId,
          CategoryName,
          SubGrpName,
          BrandName,
          TaxPerc,
          PromoName,
          AddiCessAmt,
          ...rest
        } = item;
        return rest; // only send required data for payload
      });
      var obj = {
        B_TransId: HeadObject?.A_TransId || "",
        UserCd: UserID || "",
        isApproved: isApproved,
        isRejected: isRejected,
        LineItems: items,
        Type: type,
      };
      // console.log("payload",obj);
      const response = await GET_API_RSP_Change_Approve_Update(obj);
      if (response?.status === 200) {
        fAlertToast("SUCCESS", `${name} Successfully`);
        setHeadObj((prev) => ({
          ...prev,
          ApproveStatus:
            name === "Approved" ? "POST" : HeadObject?.ApproveStatus,
        }));
        await summaryLoad();
        if (isApproved || isRejected) {
          handleClose();
        }
      } else {
        fAlertToast("FAILED", response?.response?.data?.error);
      }
    } catch (error) {
      fAlertToast("FAILED", error?.message || "Operation failed");
    }
  };

  const reverseSave = async () => {
    try {
      const isHeadValid = fValidationHead();
      if (!isHeadValid) return;
      const obj = {
        A_TransId: HeadObject?.A_TransId,
        A_UserCd: UserID,
        A_Typ: type,
      };
      const reverseRes = await RSPCRA_Reverse(obj);
      if (reverseRes?.status === 200) {
        fAlertToast("SUCCESS", "Reversed Successfully");
        const statusMap = {
          CM: "A_StatusCM",
          PM: "A_StatusPM",
          "": "ApproveStatus",
        };
        if (type in statusMap) {
          setHeadObj((prev) => ({
            ...prev,
            [statusMap[type]]: "ENTER",
          }));
        }
        await summaryLoad();
      }
    } catch (error) {
      fAlertToast("FAILED", error?.message || "Operation failed");
    }
  };

  const getReasonTypeAttributes = async () => {
    try {
      const res = await GET_API_RSP_Change_Approve_Reject_Type_GetRow();
      if (res?.status === 200) setReasonTypeList(res?.data?.ResultSet || []);
    } catch (error) {}
  };

  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      // ALL loaded rows (ignores selection)
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
      // allColumns: true,
    });
  };

  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  const handlePrintWebReport = () => {
    setWebReportOpen(true);
    let PrintURl =
      (vRdxDBKernObj?.WEB_REPORT_BASE_URL?.DefVal ?? "") +
      "WMS/PriceChange?prntyp=PRICECHANGE&TrnTyp=INVPC" +
      "&VocTyp=" +
      (HeadObject?.A_VocTyp ?? "") +
      "&VocNo=" +
      (HeadObject?.A_VocNo ?? "");
    console.log("PrintURl", PrintURl);
    setWebReportUrl(PrintURl);
  };

  useEffect(() => {
    getReasonTypeAttributes();

}, []);

// useEffect(() => {
// getBasketRows();
// }, [])

  return (
    <>
      <Grid container spacing={2}>
        {/* Header Info */}
        <Grid
          item
          xs={12}
          sx={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            backgroundColor: "white",
            padding: "16px",
            marginTop: "1rem",
            marginLeft: "1rem !important",
          }}
        >
          <Grid container spacing={1}>
            {/* Left Column */}
            <Grid item xs={12} sm={6} md={2.6}>
              {[
                { label: "Trans ID", value: HeadObject?.A_TransId },
                {
                  label: "Date",
                  value: HeadObject?.A_Date
                    ? moment(HeadObject.A_Date).format("DD/MM/YYYY")
                    : "-",
                },
                { label: "Trans Location ID", value: HeadObject?.A_Loc },
                { label: "Trans Loc Name", value: HeadObject?.Loc_Name },
              ].map((item, idx) => (
                <Grid
                  item
                  xs={12}
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    minWidth: 0,
                    py: 0.25,
                  }}
                >
                  <Typography
                    variant="body2"
                    // fontWeight={600}
                    color="primary.main"
                    sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                  >
                    {item.label}
                  </Typography>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body2">{item.value || "-"}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Middle Column */}
            <Grid item xs={12} sm={6} md={2.4}>
              {[
                { label: "Status", value: HeadObject?.A_Status, status: true },
                {
                  label: "CM Status",
                  value: HeadObject?.A_StatusCM,
                  status: true,
                },
                {
                  label: "PM Status",
                  value: HeadObject?.A_StatusPM,
                  status: true,
                },
                {
                  label: "Confirm Status",
                  value: HeadObject?.ApproveStatus,
                  status: true,
                },
              ].map((item, idx) => (
                <Grid
                  item
                  xs={12}
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    minWidth: 0,
                    py: 0.25,
                  }}
                >
                  <Typography
                    variant="body2"
                    // fontWeight={600}
                    color="primary.main"
                    sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                  >
                    {item.label}
                  </Typography>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    {item.status ? (
                      <div
                        style={{
                          ...getStatusStyle(item.value),
                          borderRadius: "4px",
                          padding: "2px 4px",
                          //fontWeight: "bold",
                        }}
                      >
                        {item.value}
                      </div>
                    ) : (
                      <Typography variant="body2">
                        {item.value || "-"}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Right Column - Locations */}
            <Grid item xs={12} md={7}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1,
                  minWidth: 0,
                  py: 0.25,
                }}
              >
                <Typography
                  variant="div"
                  color="primary.main"
                  sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                >
                  Locations
                </Typography>
<Box sx={{ flex: 1, minWidth: 0 }}>
  <Typography
    variant="body2"
    sx={{
      display: "-webkit-box",
      WebkitLineClamp: 3,     // ⬅ limit to 3 lines
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "normal",
    }}
  >
    {HeadObject?.LoccsvName || "-"}
  </Typography>
</Box>

              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                border={"2px soild red"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1,
                  minWidth: 0,
                  py: 0.25,
                }}
              >
                <Typography
                  variant="div"
                  color="primary.main"
                  sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                >
                  Created Date
                </Typography>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
                    {moment(HeadObject?.CreatedDate).format("DD/MM/YYYY")}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1,
                      minWidth: 0,
                      py: 0.25,
                      border: "1px soild red",
                    }}
                  >
                    <Typography
                      variant="div"
                      color="primary.main"
                      sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                    >
                      Created By
                    </Typography>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
                        {HeadObject?.CreatedBy}
                      </Typography>
                    </Box>
                  </Grid>
                  {/* show buttons grid greater than screen size of 1150px */}
                  {!btnMediaQuery && (
                    <Grid
                      item
                      xs={8}
                      md={8}
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="flex-start"
                      alignSelf="flex-end"
                    >
                      <Box display="flex" flexWrap={"wrap"} gap={1} mt={1}>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ textTransform: "capitalize", minWidth: 100 }}
                          onClick={() => fSave(false, "Saved")}
                          disabled={isActionButtonDisabled}
                        >
                          Save
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ textTransform: "capitalize", minWidth: 100 }}
                          onClick={() => {
                            confirmAlert({
                              title: "Confirm Approve",
                              message: "Are you sure you want to approve?",
                              buttons: [
                                {
                                  label: "Yes",
                                  onClick: () => fSave(true, "Approved"),
                                },
                                {
                                  label: "No",
                                  onClick: () => {},
                                },
                              ],
                            });
                          }}
                          disabled={isActionButtonDisabled}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          size="small"
                          sx={{ textTransform: "capitalize" }}
                          onClick={() => {
                            confirmAlert({
                              title: "Confirm Reject",
                              message: "Are you sure you want to reject?",
                              buttons: [
                                {
                                  label: "Yes",
                                  onClick: () => fSave(false, "Rejected", true),
                                },
                                {
                                  label: "No",
                                  onClick: () => {},
                                },
                              ],
                            });
                          }}
                          disabled={isActionButtonDisabled}
                        >
                          Reject
                        </Button>
                        {shouldShowReverseButton() && (
                          <Button
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ textTransform: "capitalize" }}
                            onClick={() => {
                              confirmAlert({
                                title: "Confirm Action",
                                message: "Are you sure you want to Reverse?",
                                buttons: [
                                  {
                                    label: "Yes",
                                    onClick: () => {
                                      reverseSave();
                                    },
                                  },
                                  {
                                    label: "No",
                                    onClick: () => {},
                                  },
                                ],
                              });
                            }}
                          >
                            Reverse
                          </Button>
                        )}
                        {type === "" && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={
                              HeadObject?.A_VocNo === ("" || null) &&
                              HeadObject?.A_VocTyp === ("" || null)
                            }
                            onClick={handlePrintWebReport}
                          >
                            Print Report
                          </Button>
                        )}
                        <Tooltip title="Export CSV">
                          <IconButton
                            color="primary"
                            onClick={handleExport}
                            size="small"
                          >
                            <DownloadOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Print">
                          <IconButton
                            color="primary"
                            onClick={handlePrint}
                            size="small"
                          >
                            <PrintOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1,
                  minWidth: 0,
                  py: 0.25,
                }}
              >
                <Typography
                  variant="div"
                  color="primary.main"
                  sx={{ flex: `0 0 ${LABEL_WIDTH}px`, pr: 1 }}
                >
                  Narration
                </Typography>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
                    {HeadObject?.A_Narration}
                  </Typography>
                </Box>
              </Grid>

              {/* show buttons grid upto screen size of 1150px */}
              {btnMediaQuery && (
                <Grid
                  item
                  xs={12}
                  md={12}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-start"
                  alignSelf="flex-end"
                >
                  <Box display="flex" flexWrap={"wrap"} gap={1} mt={1}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ textTransform: "capitalize", minWidth: 80 }}
                      onClick={() => fSave(false, "Saved")}
                      disabled={isActionButtonDisabled}
                    >
                      Save
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ textTransform: "capitalize", minWidth: 80 }}
                      onClick={() => {
                        confirmAlert({
                          title: "Confirm Approve",
                          message: "Are you sure you want to approve?",
                          buttons: [
                            {
                              label: "Yes",
                              onClick: () => fSave(true, "Approved"),
                            },
                            {
                              label: "No",
                              onClick: () => {},
                            },
                          ],
                        });
                      }}
                      disabled={isActionButtonDisabled}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                      onClick={() => {
                        confirmAlert({
                          title: "Confirm Reject",
                          message: "Are you sure you want to reject?",
                          buttons: [
                            {
                              label: "Yes",
                              onClick: () => fSave(false, "Rejected", true),
                            },
                            {
                              label: "No",
                              onClick: () => {},
                            },
                          ],
                        });
                      }}
                      disabled={isActionButtonDisabled}
                    >
                      Reject
                    </Button>
                    {shouldShowReverseButton() && (
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ textTransform: "capitalize" }}
                        onClick={() => {
                          confirmAlert({
                            title: "Confirm Action",
                            message: "Are you sure you want to Reverse?",
                            buttons: [
                              {
                                label: "Yes",
                                onClick: () => {
                                  reverseSave();
                                },
                              },
                              {
                                label: "No",
                                onClick: () => {},
                              },
                            ],
                          });
                        }}
                      >
                        Reverse
                      </Button>
                    )}
                    {type === "" && (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={
                          HeadObject?.A_VocNo === ("" || null) &&
                          HeadObject?.A_VocTyp === ("" || null)
                        }
                        onClick={handlePrintWebReport}
                      >
                        Print Report
                      </Button>
                    )}
                    <Tooltip title="Export CSV">
                      <IconButton
                        color="primary"
                        onClick={handleExport}
                        size="small"
                      >
                        <DownloadOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Print">
                      <IconButton
                        color="primary"
                        onClick={handlePrint}
                        size="small"
                      >
                        <PrintOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        {/* Data Grid */}
        <Grid item xs={12}>
          <Box
            sx={{
              height: { xs: "35vh", sm: "38vh", md: "52vh", lg: "56vh",xl:"62vh" },
              mt: 0.5,
            }}
          >
            <DataGridPro
              rows={DetailData}
              apiRef={apiRef}
              getRowClassName={(params) =>
                Number(params.row?.B_Status) ? "reject-row" : ""
              }
              columns={[
                {
                  field: "AgingStock",
                  headerName: "Aging Stock",
                  width: 15,
                  align: "center",
                  headerAlign: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenAging(params.row);
                      }}
                    >
                      <AccessTimeIcon fontSize="small" />
                    </IconButton>
                  ),
                },
                {
                  field: "StockView",
                  headerName: "Stock",
                  width: 15,
                  align: "center",
                  headerAlign: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenStock(params.row);
                      }}
                    >
                      <LocalMallIcon fontSize="small" />
                    </IconButton>
                  ),
                },

                {
                  field: "Promotion",
                  headerName: "Promotion",
                  width: 15,
                  align: "center",
                  headerAlign: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => (
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenPromotion(params.row.B_PromoId);
                      }}
                    >
                      <LocalOffer fontSize="small" />
                    </IconButton>
                  ),
                },

                {
                  field: "B_Itmcd",
                  headerName: "Item Code",
                  width: 55,
                  align: "left",
                  headerAlign: "left",
                },
                {
                  field: "ItemName",
                  headerName: "Item Name",
                  minWidth: 120,
                  headerAlign: "left",
                  align: "left",
                  renderCell: ({ value }) => (
                    <Tooltip title={value}>
                      <Typography
                        sx={{
                          whiteSpace: "normal",
                          lineHeight: "1.4em",
                          fontSize: "10px",
                        }}
                      >
                        {value}
                      </Typography>
                    </Tooltip>
                  ),
                },
                {
                  field: "UnitName",
                  headerName: "Unit",
                  width: 40,
                  headerAlign: "left",
                  align: "left",
                },
                {
                  field: "B_CostPrice",
                  headerName: "Cost Price",
                  width: 58,
                  align: "right",
                  headerAlign: "right",
                },
                {
                  field: "B_Old_RSP",
                  headerName: "RSP",
                  width: 30,
                  align: "right",
                  headerAlign: "right",
                  cellClassName: ({ row }) =>
                    getOldCellClass(row.B_Old_RSP, row.B_New_RSP),
                },
                {
                  field: "B_Old_RSPVat",
                  headerName: "VAT RSP",
                  width: 40,
                  align: "right",
                  headerAlign: "center",
                  cellClassName: ({ row }) =>
                    getOldCellClass(row.B_Old_RSPVat, row.B_New_RSPVat),
                },
                {
                  field: "B_Old_GPPerc",
                  headerName: "GP %",
                  width: 40,
                  align: "right",
                  headerAlign: "right",
                  cellClassName: ({ row }) =>
                    getOldCellClass(row.B_Old_GPPerc, row.B_New_GPPerc),
                },
                {
                  field: "B_New_RSP",
                  headerName: "RSP",
                  width: 40,
                  align: "right",
                  headerAlign: "right",
                  cellClassName: ({ row }) =>
                    getNewCellClass(row.B_Old_RSP, row.B_New_RSP),
                },
                {
                  field: "B_New_RSPVat",
                  headerName: "VAT RSP",
                  width: 40,
                  align: "right",
                  headerAlign: "center",
                  cellClassName: ({ row }) =>
                    getNewCellClass(row.B_Old_RSPVat, row.B_New_RSPVat),
                },
                {
                  field: "B_New_GPPerc",
                  headerName: "GP %",
                  width: 40,
                  align: "right",
                  headerAlign: "right",
                  cellClassName: ({ row }) =>
                    getNewCellClass(row.B_Old_GPPerc, row.B_New_GPPerc),
                },
                {
                  field: "B_Appr_RSP",
                  headerName: "RSP",
                  width: 40,
                  align: "center",
                  headerAlign: "center",
                  renderCell: (params) => {
                    const { row } = params;
                    if (row?.B_Old_RSP !== row?.B_New_RSP) {
                      return (
                        <TextField
                          value={row?.B_Appr_RSP ?? ""}
                          onKeyDown={stopGridArrowNavigation}
                          onChange={(e) =>
                            handleFieldEdit(
                              params,
                              e?.target?.value,
                              "B_Appr_RSP",
                              (val, currentRow) =>
                                computeApprovalFromRSP(currentRow, val)
                            )
                          }
                          //disabled={Boolean(params.row.B_Status)}
                          variant="outlined"
                          size="small"
                          inputProps={{
                            inputMode: "decimal",
                            type: "number",
                            step: "any",
                          }}
                          sx={{
                            width: 60,
                            "& .MuiOutlinedInput-input": {
                              textAlign: "center",
                              padding: "4px 6px",
                              fontSize: "10px",
                            },
                          }}
                        />
                      );
                    }
                    return null;
                  },
                },

                {
                  field: "B_Appr_RSPVat",
                  headerName: "VAT RSP",
                  width: 40,
                  align: "center",
                  headerAlign: "center",
                  renderCell: (params) => {
                    const { row } = params;
                    if (row?.B_Old_RSPVat !== row?.B_New_RSPVat) {
                      return (
                        <TextField
                          value={row?.B_Appr_RSPVat ?? ""}
                          onKeyDown={stopGridArrowNavigation}
                          onChange={(e) =>
                            handleFieldEdit(
                              params,
                              e?.target?.value,
                              "B_Appr_RSPVat",
                              (val, currentRow) =>
                                computeApprovalFromVAT(currentRow, val)
                            )
                          }
                          //disabled={Boolean(params.row.B_Status)}
                          variant="outlined"
                          size="small"
                          inputProps={{
                            inputMode: "decimal",
                            type: "number",
                            step: "any",
                          }}
                          sx={{
                            width: 60,
                            "& .MuiOutlinedInput-input": {
                              textAlign: "center",
                              padding: "4px 6px",
                              fontSize: "10px",
                            },
                          }}
                        />
                      );
                    }
                    return null;
                  },
                },

                {
                  field: "B_Appr_GPPerc",
                  headerName: "GP %",
                  width: 40,
                  align: "right",
                  headerAlign: "right",
                },
                {
                  field: "B_LocationCSV",
                  headerName: "Locations",
                  width: 180,
                  headerAlign: "left",
                  align: "left",
                  renderCell: (params) => {
                    const { row } = params;
                    // Always pass an ARRAY to the autocomplete
                    const xValueArray = toArrayFromCSV(row?.B_LocationCSV);
                    return (
                      <div style={{ width: "100%" }}>
                        <MultiLocationAutocomplete
                          xValue={xValueArray}
                          options={Location ?? []} // [{Uid, Name1}, ...]
                          placeholder="Search Location"
                          setValue={(updatedUIDsArray) => {
                            // Save back as CSV (or keep as array if you want)
                            handleFieldEdit(
                              params,
                              updatedUIDsArray,
                              "B_LocationCSV",
                              (uids) => toCSVFromArray(uids)
                            );
                          }}
                          //xDisabled={Boolean(params.row.B_Status)}
                        />
                      </div>
                    );
                  },
                },
                {
                  field: "B_Type",
                  headerName: "Type",
                  width: 100,
                  headerAlign: "left",
                  align: "left",
                },
                {
                  field: "CompetitorName",
                  headerName: "Competitor",
                  width: 70,
                  headerAlign: "left",
                  align: "left",
                },
                {
                  field: "B_Status",
                  headerName: "Reject",
                  width: 53,
                  align: "center",
                  sortable: false,
                  filterable: false,
                  disableColumnMenu: true,
                  renderCell: (params) => {
                    const checked = Boolean(Number(params.row?.B_Status));
                    return (
                      <Checkbox
                        size="small"
                        checked={checked}
                        onChange={(e) =>
                          handleFieldEdit(params, e.target.checked, "B_Status")
                        }
                      />
                    );
                  },
                },
                {
                  field: "B_RejectDetail",
                  headerName: "Reject Type",
                  width: 120,
                  headerAlign: "left",
                  align: "left",
                  renderCell: (params) => (
                    <Select
                      value={params.row.B_RejectDetail || ""}
                      onChange={(e) =>
                        handleFieldEdit(
                          params,
                          e?.target?.value,
                          "B_RejectDetail"
                        )
                      }
                      //disabled={Boolean(params.row.B_Status)}
                      size="small"
                      displayEmpty
                      fullWidth
                    >
                      {reasonTypeList?.map((opt, index) => (
                        <MenuItem key={opt.UID + index} value={opt.UID}>
                          {opt.NAME1}
                        </MenuItem>
                      ))}
                    </Select>
                  ),
                },

                {
                  field: "B_RejectNarration",
                  headerName: "Reject Narration",
                  minWidth: 130,
                  headerAlign: "left",
                  align: "left",
                  renderCell: (params) => {
                    return (
                      <EditableRejectNarration
                        value={params.row.B_RejectNarration}
                        onSave={(newValue) =>
                          handleFieldEdit(params, newValue, "B_RejectNarration")
                        }
                        // isDisable={Boolean(params.row.B_Status)}
                      />
                    );
                  },
                },
                {
                  field: "Department",
                  headerName: "Main Group",
                  width: 90,
                  headerAlign: "left",
                  align: "left",
                },
                {
                  field: "SubGrpName",
                  headerName: "Sub Group",
                  width: 90,
                  headerAlign: "left",
                  align: "left",
                },
                {
                  field: "CategoryName",
                  headerName: "Category",
                  width: 90,
                  headerAlign: "left",
                },
                {
                  field: "BrandName",
                  headerName: "Brand",
                  width: 90,
                  align: "left",
                  headerAlign: "left",
                },
                {
                  field: "B_VendorName",
                  headerName: "Supplier",
                  width: 200,
                  headerAlign: "left",
                  align: "left",
                },
              ]}
              columnGroupingModel={columnGroupingModel}
              experimentalFeatures={{ columnGrouping: true }}
              disableRowSelectionOnClick
              getRowId={(row) => row?.B_Srno}
              rowHeight={35}
              headerHeight={40}
              hideFooter
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-cell": {
                  padding: "0px 2px",
                  fontSize: "9px",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
                "& .MuiDataGrid-row.reject-row": {
                  backgroundColor: "#ffe5e5",
                },
                "& .MuiDataGrid-columnHeader": {
                  whiteSpace: "normal",
                  lineHeight: "1.2em",
                  paddingTop: "8px",
                  paddingBottom: "1px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  fontSize: "9px",
                },
                // "& .MuiDataGrid-columnHeaderTitleContainer": {
                //   textAlign: "center",
                //   justifyContent: "center",
                // },
                "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
                  {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                "& .MuiDataGrid-pinnedColumnHeaders": {
                  zIndex: 2,
                  textAlign: "left",
                },
                "& .MuiDataGrid-pinnedColumns--left": {
                  boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
                },
              }}
              initialState={{
                pinnedColumns: !vMediaQuery
                  ? {
                      left: [
                        "AgingStock",
                        "StockView",
                        "Promotion",
                        "B_Itmcd",
                        "ItemName",
                        "UnitName",
                      ],
                    }
                  : {},
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Dialog
        open={agingModal.open}
        onClose={handleCloseAging}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: "95vw", // take up 95% of the viewport width
            maxWidth: "none", // prevent any other max-width from applying
          },
        }}
      >
        <Toolbar sx={toolbar}>
          <span>&nbsp;</span>
          <DialogTitle
            sx={{
              backgroundColor: "#0d73bb",
              color: "white",
              padding: "0 4px !important",
            }}
          >
            Aging Stock
          </DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseAging}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Item:</strong> {agingModal.row?.B_Itmcd}
            {agingModal.row?.ItemName}
          </Typography>
          {/* TODO: Replace this with your actual aging stock component or API-driven content */}
          <div style={{ height: 550, width: "100%" }}>
            <DataGridPro
              rows={agingRows}
              columns={agingColumns}
              getRowId={(row) => row.Loc}
              headerHeight={40}
              rowHeight={32}
              loading={loadingAging}
              hideFooterPagination
//          components={{
//   Footer: () => (
//     <GridFooterContainer
//       sx={{
//         display: "flex",
//         borderTop: "1px solid #bbb",
//         background: "#f0f0f0",
//         fontWeight: "bold",
//       }}
//     >
//       {agingColumns.map((col) => {
//         // Left “TOTAL” cell
//         if (col.field === "Loc") {
//           return (
//             <Box
//               key={col.field}
//               sx={{
//                 width: col.width ?? col.minWidth ?? 100,
//                 pl: 1,
//                 boxSizing: "border-box",
//                 borderRight: "1px solid #ddd",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               TOTAL
//             </Box>
//           );
//         }

//         const val = totals[col.field];
//         return (
//           <Box
//             key={col.field}
//             sx={{
//               // Always respect the same width hierarchy as the DataGrid column
//               width: col.width ?? col.minWidth ?? 100,
//               flex: col.flex ? `${col.flex} 0 auto` : "0 0 auto",
//               minWidth: col.minWidth,
//               textAlign: col.align || "right",
//               boxSizing: "border-box",
//              // borderRight: "1px solid #0ddd",
//               pr: 1,
//                backgroundColor:
//                 col.field === "StkQty" || col.field === "StkValue"
//                   ? "#d0d6e0" // choose any darker/lighter shade you prefer
//                   : "transparent",
//             }}
//           >
//             {val !== undefined ? val.toFixed(2) : ""}
//           </Box>
//         );
//       })}
//     </GridFooterContainer>
//   ),
// }}

              sx={{
                "& .Stk-cell, & .StkVal-cell": {
                  backgroundColor: "#f5f5f5",
                  border: "1px solid lightgray",
                },
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
                "& .MuiDataGrid-pinnedColumnHeaders, & .MuiDataGrid-columnHeaders":
                  {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                "& .MuiDataGrid-pinnedColumns--left": {
                  boxShadow: "4px 0 6px -4px rgba(37,15,15,0.2)",
                },
              }}
              initialState={{
                pinnedColumns: !vMediaQuery ? { left: ["Loc", "LocName"] } : {},
              }}
            />
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={stockModal.open}
        onClose={handleCloseStock}
        maxWidth="sm"
        fullWidth
      >
        <Toolbar sx={toolbar}>
          <span>&nbsp;</span>
          <DialogTitle
            sx={{
              backgroundColor: "#0d73bb",
              color: "white",
              padding: "0 4px !important",
            }}
          >
            Current Stock
          </DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseStock}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Item:</strong> {stockModal.row?.B_Itmcd} —{" "}
            {stockModal.row?.ItemName}
          </Typography>

          <div style={{ height: 300, width: "100%" }}>
            <DataGrid
              rows={stockRows}
              columns={stockColumns}
              getRowId={(row) => row.id}
              headerHeight={40}
              rowHeight={32}
              hideFooterPagination
              components={{
                Footer: () => (
                  <GridFooterContainer
                    sx={{
                      display: "flex",
                      width: "100%",
                      borderTop: "1px solid #e0e0e0",
                      fontWeight: 600,
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {/* Location footer cell */}
                    <div
                      style={{
                        flex: 1, // takes remaining space like your Location column
                        padding: "0 8px",
                        textAlign: "left",
                      }}
                    >
                      TOTAL
                    </div>
                    {/* Stock Qty footer cell */}

                    <div
                      style={{
                        width: 130, // match Stock Qty column width
                        textAlign: "center",
                      }}
                    >
                      {totalStkQty.toFixed(2)}
                    </div>
                    {/* Stock Value footer cell */}
                    <div
                      style={{
                        width: 130, // match Stock Value column width
                        textAlign: "center",
                      }}
                    >
                      {totalStkVal.toFixed(2)}
                    </div>
                  </GridFooterContainer>
                ),
              }}
              loading={loadingStock}
              sx={{
                border: 1,
                borderColor: "primary.light",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "0 8px",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  lineHeight: "32px", // vertically center text
                  fontSize: "0.8rem", // optional smaller text
                },
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
      <PromotionAutocomplete
        initialState={{
          P_PromoId: promoObj?.PromoId,
          P_FromDate: moment(promoObj?.FromDate).startOf("month").toDate(),
          P_ToDate: moment(promoObj?.ToDate).toDate(),
          P_Loc: toArrayFromCSV(promoObj?.Loc),
          P_Narration: promoObj?.Narration,
          isActive:promoObj?.isActive
        }}
        xValue={promoObj?.PromoId}
        xOpen={promotionModal}
        xRows={filteredBasketRows}
        xRowsOrginal={basketRows}
        updateRows={setfilteredBasketRows}
        getBasketRows={getBasketRows}
        xModalfullScreen={vMediaQuery}
        xModalHeight={vMediaQuery ? "100vh" : "65vh"}
        vMediaQuery={vMediaQuery}
        xCloseModal={() => {
          setPromotionModal(false)
        setBasketRows([]);
        }}
        xHeadSelectedLoc={headSelectedLocation}
        xLocation={locationArr}
      />
      <GCWebReport
        xfCloseWebReportModal={() => setWebReportOpen(false)}
        xWebReportUrlModal={webReportUrl}
        xTitle="Report"
        xWebReportModal={webReportOpen}
      />
    </>
  );
};

// put this once (outside the component or in a utils file)
const stopGridArrowNavigation = (e) => {
  const blocked = [
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
  ];
  if (blocked.includes(e.key)) e.stopPropagation();
};
const EditableRejectNarration = ({
  value: initialValue,
  onSave,
  isDisable,
}) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e?.target.value);
  };

  const handleBlur = () => {
    onSave(value);
  };

  const handleKeyDown = (e) => {
    stopGridArrowNavigation(e);

    if (e.key === " ") e.stopPropagation();
  };

  return (
    <div style={{ width: "100%" }}>
      <TextField
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        size="small"
        disabled={isDisable}
        rows={2}
        fullWidth
        autoComplete="off"
        sx={{ "& textarea": { fontSize: "12px" } }}
      />
    </div>
  );
};

export default RSPChangeApproveModal;
